module.exports = __webpack_public_path__ + "static/media/logo_black.53fa24f0.svg";